var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowSwapHorizontal1 = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.75994C3.31 9.75994 3.12 9.68994 2.97 9.53994C2.68 9.24994 2.68 8.76994 2.97 8.47994L7.98 3.46994C8.27 3.17994 8.75 3.17994 9.04 3.46994C9.33 3.75994 9.33 4.23994 9.04 4.52994L4.03 9.53994C3.89 9.67994 3.69 9.75994 3.5 9.75994Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.76001H3.5C3.09 9.76001 2.75 9.42001 2.75 9.01001C2.75 8.60001 3.09 8.26001 3.5 8.26001H20.5C20.91 8.26001 21.25 8.60001 21.25 9.01001C21.25 9.42001 20.91 9.76001 20.5 9.76001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7501 13.0001C20.9401 13.0001 21.1301 13.0701 21.2801 13.2201C21.5701 13.5101 21.5701 13.9901 21.2801 14.2801L16.2701 19.2901C15.9801 19.5801 15.5001 19.5801 15.2101 19.2901C14.9201 19.0001 14.9201 18.5201 15.2101 18.2301L20.2201 13.2201C20.3601 13.0801 20.5601 13.0001 20.7501 13.0001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13H20.75C21.16 13 21.5 13.34 21.5 13.75C21.5 14.16 21.16 14.5 20.75 14.5H3.75C3.34 14.5 3 14.16 3 13.75C3 13.34 3.34 13 3.75 13Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowSwapHorizontal1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-swap-horizontal-1.d974f4f9.svg";
export { ForwardRef as ReactComponent };